export const undefinedSymbol = Symbol('undefined');
export const nullSymbol = Symbol('null');
